import { AlertBox } from '@iwoca/orion';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl
} from 'react-intl';
import { connect } from 'react-redux';

import messages from './BusinessBankStatement.messages';
import styles from './BusinessBankStatement.module.css';
import BusinessBankStatementManual from './BusinessBankstatementManual/BusinessBankStatementManual';
import BusinessBankStatementTrueLayer from './BusinessBankStatementTrueLayer/BusinessBankStatementTrueLayer';
import TrueLayerAlertBox from './BusinessBankStatementTrueLayer/TrueLayerAlertBox';
import { TTrueLayerBank } from './BusinessBankStatementTrueLayer/TrueLayerModal';
import { getTrueLayerBanks } from '../../../lendingAPI/lendingAPISelector';
import { RootState } from '../../../reducers';
import { getTrueLayerLinkedBankAccounts } from '../TradingHistory.selectors';
import { TOffersDataRequirementsResolutionMethods } from '../types';

const mapStateToProps = (state: RootState) => {
    return {
        trueLayerBanks: getTrueLayerBanks(state),
        trueLayerLinkedBankAccount: getTrueLayerLinkedBankAccounts(state)
    };
};

const BankStatementOpenBanking = ({
    setTrueLayerAlertStatus,
    trueLayerBanks,
    trueLayerLinkedBankAccount,
    linkedBankAccount,
    trueLayerAlertStatus,
    isOptional
}: {
    setTrueLayerAlertStatus: (
        status: 'success' | 'failure' | 'cancel' | null
    ) => void;
    trueLayerBanks: TTrueLayerBank[];
    trueLayerLinkedBankAccount:
        | TOffersDataRequirementsResolutionMethods[number]['items'][0]
        | null;
    isOptional: boolean;
    linkedBankAccount: TTrueLayerBank | null;
    trueLayerAlertStatus: 'success' | 'failure' | 'cancel' | null;
} & WrappedComponentProps) => {
    return (
        <>
            <BusinessBankStatementTrueLayer
                setAlertStatus={setTrueLayerAlertStatus}
                bankList={trueLayerBanks}
            />

            {trueLayerLinkedBankAccount && linkedBankAccount && (
                <AlertBox className={styles.OBAccountStatus} variant="connect">
                    <img
                        className={styles.OBTrueLayerBankLogo}
                        src={linkedBankAccount.logo_url}
                        alt={linkedBankAccount.bank_name}
                    />{' '}
                    <strong>
                        <FormattedMessage
                            {...messages.linkedBankAccountStatus}
                            values={{
                                bankName: linkedBankAccount.bank_name
                            }}
                        />
                    </strong>
                </AlertBox>
            )}
            {trueLayerAlertStatus && (
                <TrueLayerAlertBox status={trueLayerAlertStatus} />
            )}
            <BusinessBankStatementManual isOptional={isOptional} />
        </>
    );
};

export default connect(mapStateToProps)(injectIntl(BankStatementOpenBanking));
